// extracted by mini-css-extract-plugin
export var drawerContent = "_2x-0";
export var valueBlock = "_2x-1";
export var valueBlockFrom = "_2x-2 _2x-1";
export var valueBlockTo = "_2x-3 _2x-1";